import { supabase, supabaseConfigured } from './supabaseClient'
import { getPendingCloudPhotos, deleteLocalPhoto } from './localPhotos'

const BUCKET = 'progress-photos'

let flushing = false

// Drains photos with pendingCloudUpload=true: storage.upload → row insert
// → delete local copy. Failures leave the record for the next event. No
// attempt cap (matches the spec — manual delete is the escape hatch).
export async function flushPhotoUploads() {
  if (flushing) return
  if (!supabaseConfigured) return
  if (typeof navigator !== 'undefined' && navigator.onLine === false) return

  const { data: { user } = {} } = await supabase.auth.getUser()
  if (!user) return

  flushing = true
  let synced = 0
  try {
    const pending = await getPendingCloudPhotos(user.id)
    for (const photo of pending) {
      const storagePath = `${user.id}/${photo.id}.jpg`

      const { error: uploadErr } = await supabase
        .storage
        .from(BUCKET)
        .upload(storagePath, photo.blob, {
          contentType: 'image/jpeg',
          upsert: false,
        })
      // 409 here means a prior attempt already uploaded the blob; treat
      // it as success and let the row insert proceed.
      const isDuplicate = uploadErr && (
        uploadErr.statusCode === '409'
        || uploadErr.message?.toLowerCase?.().includes('already exists')
      )
      if (uploadErr && !isDuplicate) continue

      const { error: insertErr } = await supabase
        .from('progress_photos')
        .insert({
          user_id: user.id,
          date: photo.date,
          pose: photo.pose,
          storage_path: storagePath,
          caption: photo.caption || null,
        })
      if (insertErr) {
        // Orphan blob — best-effort cleanup so retries don't pile up
        // duplicates. Local record stays for the next attempt.
        await supabase.storage.from(BUCKET).remove([storagePath]).catch(() => {})
        continue
      }

      await deleteLocalPhoto(photo.id)
      synced += 1
    }
  } finally {
    flushing = false
  }

  if (synced > 0 && typeof window !== 'undefined') {
    window.dispatchEvent(new Event('phoenix:refresh'))
  }
}
